<template>
  <div class="login">
    <div class="content">
      <div class="title">
        <img src="./../../assets/image/logo.png" alt="" />
        <img src="./../../assets/image/login/title.png" alt="" />
      </div>
      <div class="formdiv">
        <h2>用户登录</h2>
        <el-form ref="form" :model="formData" @keyup.native.enter="logIn()">
          <el-form-item>
            <div class="iptItem">
              <img
                src="./../../assets/image/login/user.png"
                alt=""
                class="icon"
              />
              <el-input
                v-model="formData.account"
                placeholder="请输入您的用户名"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="iptItem">
              <img
                src="./../../assets/image/login/psd.png"
                alt=""
                class="icon"
              />
              <el-input
                v-model="formData.password"
                placeholder="请输入您的密码"
                show-password
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="actionItem">
              <el-checkbox v-model="checked">自动登录</el-checkbox>
              <a>忘记密码</a>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button class="loginBtn" :loading="loading" @click="logIn()"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "login",
  data() {
    return {
      formData: {
        account: "",
        password: "",
      },
      checked: false,
      loading: false,
    };
  },
  mounted() {
    this.setUserAccount();
  },
  methods: {
    logIn() {
      this.$api.setToken();
      if (this.formData.account && this.formData.password) {
        this.loading = true;
        this.$api
          .post("/login", {
            account: this.formData.account,
            password: this.formData.password,
          })
          .then((res) => {
            this.$api.setToken(res);
            this.getLoginUser();
            // 重置区域id
            localStorage.removeItem("place");
            // 判断是否记住密码
            this.rememberPassword();
          })
          .catch((err) => {
            this.loading = false;
          });
      } else if (!this.account) {
        this.$message.error("请输入账号");
      } else if (!this.password) {
        this.$message.error("请输入密码");
      }
    },
    // 获取用户信息
    getLoginUser() {
      this.$api
        .get("/getLoginUser")
        .then((res) => {
          if (res.orgScopes) {
            let org = {
              orgScopes: res.orgScopes,
              orgId: res.orgScopes[0].id,
              orgName: res.orgScopes[0].name,
            };
            localStorage.setItem("org", JSON.stringify(org));
          }
          this.loading = false;
          if (res.account == "yhdzhcyadmin20241231") {
            this.$router.push("/pc/acConfig");
          } else {
            this.$router.push("/");
          }
        })
        .catch((err) => {
          this.loading = false;
          // this.$message.error("");
        });
    },
    // 查找缓存中是否存在账号
    setUserAccount() {
      if (localStorage.getItem("userAccount")) {
        let userAccount = JSON.parse(localStorage.getItem("userAccount"));
        this.formData.account = userAccount.account;
        this.formData.password = userAccount.password;
      }
    },
    // 判断是否记住密码如果记住存入缓存
    rememberPassword() {
      if (this.checked) {
        let userAccount = {
          account: this.formData.account,
          password: this.formData.password,
        };
        localStorage.setItem("userAccount", JSON.stringify(userAccount));
      }
    },
  },
};
</script>
<style lang="less" scoped>
.login {
  width: 100%;
  height: 100%;
  background-image: url("./../../assets/image/login/bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    width: 927px;
    height: 725px;
    background-image: url("./../../assets/image/login/content.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    position: relative;

    .title {
      width: 70%;
      margin: 8px auto 0;
      height: 97px;
      display: flex;
      justify-content: center;
    }

    .formdiv {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 355px;
      height: 290px;

      h2 {
        font-size: 24px;
        color: #ffffff;
        line-height: 33px;
        text-align: center;
      }

      .iptItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: rgba(0, 20, 70, 0.26);
        width: 339px;
        height: 48px;
        margin: 20px auto 0;

        .icon {
          width: 21px;
          height: 22px;
          margin-left: 19px;
        }
        .el-input {
          flex: 1;
        }

        /deep/ .el-input__inner {
          height: 22px;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.7);
          font-weight: 400;
          background-color: rgba(0, 0, 0, 0) !important;
          margin: 0 12px;
          width: 270px;
          padding: 0;
          border: none;
        }

        /deep/ .el-input__icon {
          line-height: 24px;
        }
      }

      .actionItem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 339px;
        height: 24px;
        margin: 16px auto 0;
        font-size: 14px;
        color: #ffffff;

        /deep/ .el-checkbox__inner {
          width: 24px;
          height: 24px;
          background: rgba(0, 20, 70, 0.26);
          border-radius: 2px;
          border: 1px solid rgba(0, 129, 243, 0.78);
        }

        /deep/ .el-checkbox__inner::after {
          height: 13px;
          left: 7px;
          width: 7px;
        }

        /deep/ .el-checkbox__label {
          color: #ffffff;
        }
        a {
          color: #ffffff;
        }
      }

      .loginBtn {
        margin-top: 19px;
        width: 355px;
        height: 64px;
        background-image: url("./../../assets/image/login/btn.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        font-size: 20px;
        color: #ffffff;
        text-align: center;
        border: none;
        background-color: rgba(0, 0, 0, 0);
      }
      /deep/ .el-button.is-loading:before {
        background-color: rgba(255, 255, 255, 0);
      }
    }
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/login.vue